export const ACTION_NAME = {
  SIGNUP_USER: 'SIGNUP_USER',
  SIGNIN_USER: 'SIGNIN_USER',
  SIGNOUT_USER: 'SIGNOUT_USER',
  KEEP_AUTH_USER: 'KEEP_AUTH_USER',
  GET_MY_STORE: 'GET_MY_STORE',
  UPDATE_STORE: 'UPDATE_STORE',
  UPDATE_STORE_LOGO: 'UPDATE_STORE_LOGO',
  CREATE_SALE_MANAGER: 'CREATE_SALE_MANAGER',
  UPDATE_SALE_MANAGER: 'UPDATE_SALE_MANAGER',
  UPDATE_SALE_MANAGER_PHOTO: 'UPDATE_SALE_MANAGER_PHOTO',
  UPDATE_STATUS_SALE_MANAGER: 'UPDATE_STATUS_SALE_MANAGER',
  READ_SALE_MANAGER: 'READ_SALE_MANAGER',
  READ_SALE_MANAGERS: 'READ_SALE_MANAGERS',
  DELETE_SALE_MANAGER: 'DELETE_SALE_MANAGER',
  READ_PRODUCTS: 'READ_PRODUCTS',
  UPDATE_PRODUCT: 'UPDATE_PRODUCT',
  CREATE_PRODUCT: 'CREATE_PRODUCT',
  DELETE_PRODUCT: 'DELETE_PRODUCT',
  UPDATE_PRODUCT_IMAGE: 'UPDATE_PRODUCT_IMAGE',
  ADD_CHAT: 'ADD_CHAT',
  READ_CHATS: 'READ_CHATS',
  MARK_SALE_MANAGER_CHATS_AS_READ: 'MARK_SALE_MANAGER_CHATS_AS_READ',
  MARK_ADMIN_CHATS_AS_READ: 'MARK_ADMIN_CHATS_AS_READ',
  ADD_SALE: 'ADD_SALE',
  READ_SALES: 'READ_SALES',
  DELETE_SALE: 'DELETE_SALE',
  READ_SALES_SUMMARY: 'READ_SALES_SUMMARY',
  READ_SALES_LIVE: 'READ_SALES_LIVE',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  UPDATE_STORE_OWNER: 'UPDATE_STORE_OWNER',
  UPDATE_STORE_OWNER_PHOTO: 'UPDATE_STORE_OWNER_PHOTO',
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
  TOGGLE_CHAT_LIST: 'TOGGLE_CHAT_LIST',
  TOGGLE_PROFILE: 'TOGGLE_PROFILE',
  TOGGLE_EMOJI_DRAWER: 'TOGGLE_EMOJI_DRAWER',
};
